module.exports = __webpack_public_path__ + "components/country-flag/static/ug-793810dd1970afca981813db3710dad6.svg";